/* npx-intro.js: bannern på startsidan (northpix.se, Enterprise).
   Agent 2, 2026-10-18. Portat ur arkivets <script id="sokplats"> (index.template.html r.2402) utan arkivets beroenden.

   Två jobb:
   1. Dockningen av sökpillen. Det finns en enda pill, den som ligger i bannern (.npx-sok i .npx-sok-slot). Den
      flyttas med transform, aldrig med layout, så toppradens höjd rörs aldrig och inget hoppar:
        - på datorn (>= 768 px) följer pillen med sidan uppåt tills den hamnar i toppraden och blir sittande där
        - sista MORF (120) px av vägen morfar den: --sf går 1 -> 0 (höjd, sidopadding och textstorlek i CSS)
        - dockad: mellan logotypen och ikonerna i headern (mäts), samma bredd om det finns plats
        - reducerad rörelse: ingen glidande morf, pillen dockar direkt vid tröskeln
        - telefon (< 768 px): samma dockning, 46 px i bannern och 36 px i toppraden
   2. Filmen i bannern: laddas 250 ms efter load (telefon 480p), aldrig vid reducerad rörelse eller spara-data,
      spelar bara när bannern syns och pausas när fliken döljs.

   Sätter: --sf på .npx-sok-wrap, klasserna i-banner och i-dock på pillen, --ph och --sokx på :root. */
(function () {
  'use strict';

  var d = document;
  var root = d.documentElement;
  var intro = d.querySelector('[data-npx-intro]');
  if (!intro) return;

  var wrap = intro.querySelector('[data-npx-sok-wrap]');
  var slot = intro.querySelector('[data-npx-sok-slot]');
  var pill = slot ? slot.querySelector('.npx-sok') : null;
  var header = d.querySelector('store-header.header') || d.querySelector('.header');
  // Dockningens lodräta mitt är logotypcellens mitt (samma mitt som Cart och menyn), inte headerns: temats main.css
  // ger .header__logo och .header__icons margin-bottom 16px från 769 px, vilket gör headern 16 px högre än raden.
  var anchor = header ? (header.querySelector('.header__logo') || header) : null;

  function num(v, fallback) { var n = parseFloat(v); return isNaN(n) ? fallback : n; }
  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }

  var MORF = 120;                                   // px där pillen morfar, räknat från dockningen
  var MIN_W = 160;                                  // dockade pillens minsta bredd
  var PAD = num(intro.getAttribute('data-dock-pad'), 18);   // luft mellan logotypcellen och dockad pill
  var GAP = num(intro.getAttribute('data-dock-gap'), 18);   // luft mellan dockad pill och ikonerna

  var mq = null, lugn = null;
  try {
    mq = window.matchMedia('(min-width: 768px)');
    lugn = window.matchMedia('(prefers-reduced-motion: reduce)');
  } catch (e) {}

  function bred() { return !!(mq && mq.matches); }
  function reducerad() { return !!(lugn && lugn.matches); }

  /* ---------------- Dockningen ---------------- */

  var dock = { left: 0, avail: 0 };
  var raf = 0;
  var wasDesk = null;

  // Mäter cellen pillen dockar i: från logotypcellens högerkant till ikonernas vänsterkant. Headerns eget
  // .header__search är dolt på index och har ingen yta, därför mäts grannarna och inte cellen.
  function matt() {
    if (!header) return;
    var logo = header.querySelector('.header__logo');
    var icons = header.querySelector('.header__icons');
    var vw = window.innerWidth || root.clientWidth || 1280;
    var lr = logo ? logo.getBoundingClientRect() : null;
    var ir = icons ? icons.getBoundingClientRect() : null;
    // Telefon: startsidans logga i toppraden är dold, då börjar rutan vid kanten i stället för efter den tomma cellen.
    var loggaSyns = logo && window.getComputedStyle(logo).visibility !== 'hidden';
    // Växlarna (ljust/mörkt, SV | EN) står till vänster efter loggan (Jacob 2026-10-19): dockningen börjar efter dem
    var ls = header.querySelector('.npx-ls');
    var lsr = ls && ls.offsetWidth > 0 ? ls.getBoundingClientRect() : null;
    var vansterKant = lsr ? lsr.right : (lr ? lr.right : 0);
    dock.left = (!bred() && !loggaSyns && !lsr) ? 16 : Math.round(vansterKant + PAD);
    var right = ir ? ir.left - GAP : vw - 24;
    // Telefon: rutan krymper till utrymmet som finns (Ljusbordet och Varukorg får inte täckas), minst 44 px (förstoringsglaset)
    dock.avail = Math.max(bred() ? MIN_W : 44, Math.floor(right - dock.left));
    root.style.setProperty('--sokx', dock.left + 'px');
    // Telefonens fasta dockning läser läget härifrån (ingen transform per bildruta, se rita)
    var hr0 = anchor ? anchor.getBoundingClientRect() : null;
    root.style.setProperty('--npx-dock-l', dock.left + 'px');
    root.style.setProperty('--npx-dock-w', dock.avail + 'px');
    if (hr0) root.style.setProperty('--npx-dock-cy', Math.round(hr0.top + hr0.height / 2 ) + 'px');
    var ph = clamp(48 + (vw - 1280) * 6 / 720, 44, 54);
    root.style.setProperty('--ph', ph.toFixed(2) + 'px');
  }

  function aterstall() {
    if (pill) {
      if (pill.style.transform) pill.style.transform = '';
      if (pill.style.width) pill.style.width = '';
      pill.classList.remove('i-banner', 'i-dock');
    }
    if (wrap) wrap.style.removeProperty('--sf');
  }

  function rita() {
    raf = 0;
    if (!pill || !slot || !header) return;

    var desk = bred();                              // dockar på både dator och telefon (Jacob 2026-10-19)
    if (wasDesk !== null && wasDesk !== desk) aterstall();
    wasDesk = desk;
    var hr = anchor.getBoundingClientRect();
    var sr = slot.getBoundingClientRect();   // platsen rörs aldrig av transform, den är pillens naturliga läge

    // Telefon: ingen transform per bildruta (iOS scrollar före skriptet och då hackar rutan). Rutan följer sidan
    // naturligt, glider in under toppraden och byter till ett fast dockat läge med en enda klass (CSS sköter resten).
    if (!desk) {
      if (pill.style.transform) pill.style.transform = '';
      if (pill.style.width) pill.style.width = '';
      var dockad = (sr.top + sr.height / 2) <= (hr.top + hr.height);
      var sfm = dockad ? '0' : '1';
      if (wrap && wrap.style.getPropertyValue('--sf') !== sfm) wrap.style.setProperty('--sf', sfm);
      if (!pill.classList.contains('i-banner')) pill.classList.add('i-banner');
      if (pill.classList.contains('i-dock') !== dockad) pill.classList.toggle('i-dock', dockad);
      return;
    }

    var wb = sr.width;                              // bredd i bannern
    var wd = Math.min(wb, dock.avail);              // bredd dockad
    var dockCy = hr.top + hr.height / 2;            // raden i toppradens mitt (i fönstret)
    var natCy = sr.top + sr.height / 2;             // pillens naturliga mitt, rör sig med sidan
    var t = natCy - dockCy;                         // kvar till dockningen: > 0 i bannern, <= 0 när den sitter fast

    var f = t <= 0.5 ? 0 : clamp(t / MORF, 0, 1);
    if (reducerad()) f = f >= 1 ? 1 : 0;            // ingen glidande morf: dockar direkt vid tröskeln

    var w = wd + (wb - wd) * f;
    var left = dock.left + (sr.left - dock.left) * f;
    var x = left - sr.left;
    var y = f === 0 ? dockCy - natCy : 0;           // dockad: sitter kvar i toppraden medan sidan scrollar

    var tr = 'translate3d(' + x.toFixed(1) + 'px,calc(-50% + ' + y.toFixed(1) + 'px),0)';
    if (pill.style.transform !== tr) pill.style.transform = tr;
    var bw = w.toFixed(1) + 'px';
    if (pill.style.width !== bw) pill.style.width = bw;

    var sf = f.toFixed(3);
    if (wrap && wrap.style.getPropertyValue('--sf') !== sf) wrap.style.setProperty('--sf', sf);
    if (!pill.classList.contains('i-banner')) pill.classList.add('i-banner');
    pill.classList.toggle('i-dock', f === 0);
  }

  function begar() { if (!raf) raf = window.requestAnimationFrame(rita); }
  function matOm() { matt(); rita(); }

  if (pill && slot && header) {
    window.addEventListener('scroll', begar, { passive: true });
    window.addEventListener('resize', matOm);
    window.addEventListener('load', matOm);
    window.addEventListener('pageshow', matOm);
    if (mq && mq.addEventListener) mq.addEventListener('change', matOm);
    if (lugn && lugn.addEventListener) lugn.addEventListener('change', matOm);
    // Toppradens celler ändrar bredd när antalet i Cart eller Lightbox ändras och när typsnitten laddats: mät om.
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(matOm);
      ro.observe(header);
      ['.header__logo', '.header__icons'].forEach(function (s) {
        var e = header.querySelector(s);
        if (e) ro.observe(e);
      });
      ro.observe(intro);
    }
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(matOm);
    matOm();
  }

  /* ---------------- Filmen ---------------- */

  var film = intro.querySelector('video[data-src]');
  var filmStartad = false;
  var iBild = true;        // bannern syns
  var sidaSynlig = !d.hidden;

  function sparaData() {
    try { return !!(navigator.connection && navigator.connection.saveData); } catch (e) { return false; }
  }

  function spela() {
    if (!film || !filmStartad || !iBild || !sidaSynlig) return;
    var p = film.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
  function pausa() { if (film && filmStartad) film.pause(); }

  function startaFilm() {
    if (!film || filmStartad) return;
    if (reducerad() || sparaData()) return;           // spelar även på telefon (Jacob 2026-10-19), där med 480p
    filmStartad = true;
    film.muted = true;
    film.addEventListener('playing', function () { film.classList.add('spelar'); }, { once: true });
    film.src = (!bred() && film.getAttribute('data-src-mobil')) || film.getAttribute('data-src');
    film.load();
    spela();
  }

  if (film) {
    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        iBild = entries[0].isIntersecting;
        if (iBild) spela(); else pausa();
      }, { threshold: 0.03 }).observe(intro);
    }
    d.addEventListener('visibilitychange', function () {
      sidaSynlig = !d.hidden;
      if (sidaSynlig) spela(); else pausa();
    });
    var efterLoad = function () { window.setTimeout(startaFilm, 250); };
    if (d.readyState === 'complete') efterLoad(); else window.addEventListener('load', efterLoad);
    // fönstret vidgas till dator efter load (rotation, ändrad storlek): starta då
    if (mq && mq.addEventListener) mq.addEventListener('change', function () { if (d.readyState === 'complete') startaFilm(); });
  }
})();
